import React from 'react'
var functions = require("./functions.js");

// HubInputComponent - component for input on the hubs
export default class HubInput extends React.Component {

    render() {
        let inputId="input"+this.props.dbColumn;
        return(true) ? (
            <div className="hub-input">
                <label className="hub-input-label">{this.props.display_as?this.props.display_as:this.props.dbColumn}</label>
                <input className="hub-input-input" 
                        id={inputId}
                        type={this.props.type}
                        defaultValue={this.props.owner.state.hub[this.props.dbColumn]}
                        onChange={this.updateHubInputValue.bind(this)}
                        disabled={this.props.disabled}
                        style={this.getStyle(this.props.dbColumn)}
                        >
                </input>
                <button className="" title="Copy value to clipboard" onClick={() => this.copyValueToClipboard().bind(this) }><img alt='copy' height="15px" src="icons8-clone-figure-32.png"></img></button>
                &nbsp;
                {this.getButtons(this.props.dbColumn)}
                <div className="hub-input-inner">
                    {this.props.children}
                </div>
        </div>
        ) :"";
    }

    // get buttons for component
    getButtons( columnName ){
        let suggestion=this.getSuggestion(columnName);
        let res="";
        if(!suggestion){
        } else if(suggestion.foundValue){
            let hubKey="buttonHubSelect"+columnName;
            res=React.createElement('button',
                                        {"name":"button"+columnName
                                        ,"className":"hub-input-button"
                                        ,"columname":columnName
                                        ,"onClick":this.clickHubInput.bind(this)
                                        ,"key":hubKey
                                        ,"onDoubleClick":this.doubleClickHubInput.bind(this)
                                    }, suggestion.foundValue);            
        } else if(suggestion.acceptableValues) {
            let arr=[];
            suggestion.acceptableValues.forEach( val=>{
                let hubKey="buttonHubSelect"+columnName+val;
                let btn=React.createElement('button',
                                            {"name":"button"+columnName
                                            ,"columnname":columnName
                                            ,onDoubleClick:this.doubleClickHubInput.bind(this)
                                            ,key:hubKey
                                        }, val);
                arr.push(btn)
                if(arr.length===4){
                    //hubKey="buttonHubSelect"+columnName+val+"br";
                    //arr.push(React.createElement("br",{key:hubKey}));
                }
            } );
            res=React.createElement('span',{},arr);
        } 
        return res;
    }

    // updateHubInputValue
    updateHubInputValue(evt){
        if(evt){
            //this.props.hubPopupPost[this.props.dbColumn] = evt.currentTarget.value; 
            let hubPopupPost = this.props.owner.state.hubPopupPost;
            hubPopupPost[this.props.dbColumn]=evt.currentTarget.value;
            this.props.owner.state.hubPopupModified=true;
            this.props.owner.setState({
                hubPopupPost:hubPopupPost
                , hubPopupModified:true
            });
        }
    }

    // doubleClickHubInput
    doubleClickHubInput(evt){
        let columnName=evt.currentTarget.name;
        columnName=columnName.substring(6);
        let elm=document.getElementById("input"+columnName);
        elm.value=evt.currentTarget.innerHTML;
        let hubPopupPost = this.props.owner.state.hubPopupPost;
        hubPopupPost[this.props.dbColumn]=evt.currentTarget.innerHTML;
        this.props.owner.state.hubPopupModified=true;
        this.props.owner.setState({
            hubPopupPost:hubPopupPost
            , hubPopupModified:true
        });        
    }

    // clickHubInput
    clickHubInput(evt){
        let columnName=evt.currentTarget.name;
        if( document.getElementById("sshDisplayData") && columnName ){
            let data=this.props.owner.state.hubPopupDataNote.json.sshdata.data;
            columnName=columnName.substring(6);
            let suggestion = this.getSuggestion(columnName);
            if(columnName && suggestion){
                if(suggestion){
                    let foundLine=suggestion.foundLine;
                    let foundAt=suggestion.foundAt;
                    let foundLength=suggestion.foundLength;
                    if(foundLine){
                        let lines=data.split("\n");
                        let foundLineData=lines[foundLine];
                        let position=foundAt+foundLength; 
                        foundLineData = [ foundLineData.slice(0, position)
                                            , "</span>"
                                            , foundLineData.slice(position)
                                        ].join('');
                        position=suggestion.foundAt; 
                        lines[foundLine]= [ foundLineData.slice(0, position)
                                            //, '<span style="background-color:yellow" >'
                                            , '<span class="text-found" >'
                                            , foundLineData.slice(position)
                                        ].join('');
                        lines.splice(suggestion.topDisplayLine-3, 0, '<div id="topDisplayLine"></div>');
                        data=lines.join("\n")
                    }
                }
            }
            document.getElementById("sshDisplayData").innerHTML=data;
            window.location.href = "#topDisplayLine";
        }
    }

    // getStyle
    getStyle(dbColumn){
        let backgroundColor="GreenYellow";
        try {
            let suggestion = this.getSuggestion();
            if(!suggestion){
                backgroundColor=undefined;
            } else if(suggestion.foundValue){
                if( this.props.hubPopupData[dbColumn]
                    !== suggestion.foundValue
                    ){
                        backgroundColor="pink";
                }
            }
        } catch(e){
            backgroundColor="red";
        }
        return {
            background: backgroundColor
        }
    }

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    getSuggestion(columnName){
        return this.props.owner.state.hub.suggestions[columnName];        
    }

    copyValueToClipboard(){
        functions.copyToClipBoard(this.props.owner.state.hub[this.props.dbColumn])
    }
}

